import Car from "@/data/car/car";
import { capitalizeFirst } from "@/lib/capitalizeFirst";

export const getTabTitle = (title: string) => {
  return capitalizeFirst(title);
};

export const addTypeProductJsonLd = (car: Car) => {
  return {
    __html: `{
      "@context": "https://schema.org",
        "@type": "Product",
      "name" : "${car.title}",
       "image": [
        ${car.assets.images
          ?.slice(0, 5)
          .map((el) => `"${el}"`)
          .join(",")}
      ],
      "description" : "${car.title}",
      "brand" : "${car.marke}",
      "sku":"${car.internalid}",
      "offers":{
           "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "price":"${car.preis}",
            "priceCurrency":"EUR",
            "url":"${process.env.NEXT_PUBLIC_FRONTEND_URL}${car.url}",
            "itemCondition": "https://schema.org/${
              car.zustand === "Neu" ? "NewCondition" : "UsedCondition"
            }"
      }
    } `,
  };
};

export const addTypeCarJsonLd = (car: Car) => {
  return {
    __html: `{
      "@context": "https://schema.org",
      "@type": "Car",
      "name" : "${car.title}",
      "model" : "${car.model}",
      "manufacturer" : "${car.marke}",
      "vehicleConfiguration": "${car.equipmentline}",
      "productionDate": "${car.productionDate}",
      "bodyType": "${car.auspraegung || ""}",
      "color" : "${car.color}",
      "vehicleInteriorType" : "${car.interieurtyp}",
      "numberOfAxles" : "${car.radformel}",
      "numberOfDoors" : "${car.tueren}",
      "seatingCapacity" : "${car.sitze}",
      "vehicleTransmission" : "${car.getriebeart}",
      "description" : "Der „${
        car.title
      }“ zu einem TOP Preis bei Ford Kögler – Europas größter Ford Ausstellung. Dieses Angebot liefern wir Ihnen kostenfrei deutschlandweit und bieten zusätzlich die 10 Jahre Kögler Garantie.",
      "vehicleEngine": [
        { 
          "@type": "EngineSpecification", 
          "fuelType": "${car.kraftstoffart}", 
          "enginePower": {
            "@type":"QuantitativeValue",
            "value": "${car.ps}",
            "unitCode":"BHP"
          }
        }
      ],
      "mileageFromOdometer": {
        "@type":"QuantitativeValue",
        "value": "${car.kilometer}",
        "unitCode":"KMT"
      },
      "image": [
        ${car.assets.images
          ?.slice(0, 5)
          .map((el) => `"${el}"`)
          .join(",")}
      ]
    } `,
  };
};
